{
  "name": "t4t-field-nt",
  "version": "1.13.5.398",
  "private": true,
  "homepage": ".",
  "dependencies": {
    "@radix-ui/react-checkbox": "^1.3.8",
    "@radix-ui/react-radio-group": "^1.4.4",
    "@radix-ui/react-slot": "^1.3.0",
    "@radix-ui/react-tooltip": "^1.2.16",
    "@tanstack/react-table": "^8.21.3",
    "@vitejs/plugin-react": "^6.1.0",
    "algoliasearch": "^4.1.0",
    "autoprefixer": "^10.5.4",
    "axios": "^1.20.0",
    "base-64": "^1.0.0",
    "big-integer": "^1.6.48",
    "bootstrap-css-only": "^4.4.1",
    "browserslist": "^4.17.2",
    "caniuse-lite": "^1.0.30001264",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "d3": "^7.9.0",
    "i18next": "^24.2.1",
    "i18next-browser-languagedetector": "^7.0.0",
    "kelvin-to-rgb": "^1.0.2",
    "lodash": "^4.18.1",
    "lucide-react": "^1.25.0",
    "moment": "^2.24.0",
    "react": "^16.13.1",
    "react-bootstrap": "^1.0.0",
    "react-dom": "^16.13.1",
    "react-i18next": "^14.0.0",
    "react-instantsearch-dom": "^6.4.0",
    "react-lazyload": "^2.6.7",
    "react-redux": "^7.2.0",
    "react-router-bootstrap": "^0.25.0",
    "react-router-dom": "^5.1.2",
    "react-vis": "^1.12.1",
    "redux": "^4.0.5",
    "redux-logger": "^3.0.6",
    "redux-thunk": "^2.3.0",
    "tailwind-merge": "^3.6.0",
    "tailwindcss": "^3.4.19",
    "vite": "^8.2.2"
  },
  "scripts": {
    "start": "vite",
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "flow": "flow",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "lint": "eslint src",
    "lint:fix": "eslint src --fix"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@playwright/test": "^1.60.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@stylistic/eslint-plugin-js": "^4.4.1",
    "eslint": "^10.9.1",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-unused-imports": "^4.4.1",
    "flow-bin": "^0.122.0",
    "globals": "^15.12.0",
    "jsdom": "^30.0.1",
    "postcss": "^8.5.21",
    "vitest": "^4.1.11"
  }
}
